import { motion } from 'motion/react';
import { Users, Briefcase, Crown } from 'lucide-react';
import { useTranslation } from '../i18n';

const personas = [
  {
    icon: Users,
    titleKey: 'customerPersonas.personas.families.title',
    subtitleKey: 'customerPersonas.personas.families.subtitle',
    descriptionKey: 'customerPersonas.personas.families.description',
    color: '#C6A667',
  },
  {
    icon: Briefcase,
    titleKey: 'customerPersonas.personas.entrepreneurs.title',
    subtitleKey: 'customerPersonas.personas.entrepreneurs.subtitle',
    descriptionKey: 'customerPersonas.personas.entrepreneurs.description',
    color: '#C6A667',
  },
  {
    icon: Crown,
    titleKey: 'customerPersonas.personas.elite.title',
    subtitleKey: 'customerPersonas.personas.elite.subtitle',
    descriptionKey: 'customerPersonas.personas.elite.description',
    color: '#C6A667',
  },
];

export function CustomerPersonas() {
  const { t } = useTranslation();
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-[#0A1A33] mb-4 font-bold font-normal text-[36px]">{t('customerPersonas.section.title')}</h2>
          <p className="text-gray-600">{t('customerPersonas.section.subtitle')}</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {personas.map((persona, index) => (
            <motion.div
              key={persona.titleKey}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-2xl p-8"
            >
              <div className="mb-6 inline-flex p-4 bg-gradient-to-br from-[#0A1A33] to-[#0A1A33]/80 rounded-xl">
                <persona.icon className="w-8 h-8 text-[#C6A667]" />
              </div>
              
              <h3 className="text-[#0A1A33] mb-2 text-[16px] font-bold">{t(persona.titleKey)}</h3>
              <p className="text-sm text-gray-500 mb-4">{t(persona.subtitleKey)}</p>
              <p className="text-gray-600 leading-relaxed">{t(persona.descriptionKey)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
